import React from 'react'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import OppsImg from 'public/assets/img/e-oops.png'
import LOGO from '-!raw-loader!public/assets/svg/Logo_01.svg'
import classNames from 'classnames'

const styleSheet = theme => ({
    container: {
        width: '100%',
        height: '100%',
        background: theme.palette.common.white,
    },

    innerContainer: {
        width: 600,
        margin: '0 auto',
        marginTop: 75,
    },

    offlineMessageContainer: {
        display: 'flex',
    },

    heading: {
        fontSize: 22,
        fontWeight: 400,
    },

    logo: {
        background: `url(${OppsImg}) no-repeat right bottom`,
        width: 194,
        height: 237,

        [theme.breakpoints.down('sm')]: {
            zoom: 0.5,
        },
    },

    message: {
        fontSize: 14,
        [theme.breakpoints.down('sm')]: {
            width: 250,
        },
    },

    messageContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        marginLeft: 20,
    },

    yvLogo: {
        width: 158,
        height: 35,

        '& svg .logo_01_st1': {
            fill: 'rgb(8, 0, 30)',
        },

        '& svg.yv-logo-svg': {
            width: '100%',
            height: '100%',
        },
    },

    anchor: {
        display: 'flex',
        justifyContent: 'flex-end',

        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            zoom: 0.5,
        },
    },

    contactUS: {
        textDecoration: 'underline',
    },
})

const style = injectSheet(styleSheet)

const OfflineExperience = ({ classes, className }) => (
    <div className={classNames(classes.container, className)}>
        <div className={classes.innerContainer}>
            <a className={classes.anchor} href="https://www.youvisit.com/">
                <div className={classes.yvLogo} dangerouslySetInnerHTML={{ __html: LOGO }} />
            </a>

            <div className={classes.offlineMessageContainer}>
                <div className={classes.logo} />

                <div className={classes.messageContainer}>
                    <h1 className={classes.heading}>Experience Offline!</h1>
                    <p className={classes.message}>
                        This experience has either been turned off or does not exist.
                        <br />
                        Please contact our{' '}
                        <a
                            className={classes.contactUS}
                            href="mailto:EABDigitalExperience@eab.com?Subject=My%20Experience%20is%20Offline"
                        >
                            Sales Team
                        </a>{' '}
                        for assistance.
                    </p>
                </div>
            </div>
        </div>
    </div>
)

export default compose(style, pure)(OfflineExperience)
